"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VelocityUnitSchema = void 0;
const zod_1 = require("zod");
exports.VelocityUnitSchema = zod_1.z.enum(['km_h', 'm_s', 'fpm', 'ft_s']);
exports.default = exports.VelocityUnitSchema;
//# sourceMappingURL=VelocityUnitSchema.js.map